import './RangeSlider.less';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import Slider from 'rc-slider';

const Range = Slider.createSliderWithTooltip(Slider.Range);

/**
 * @param allowCross defines if sliders within range can cross each other
 * @param fractionDigits defines decimal value to which min and max value in dummy-rc-slider tooltip is rounded
 * @param marks defines object with key: value pairs on the range to which user can (pin/navigate) slider
 * @param max defines maximum value of range
 * @param min defines minimum value of range
 * @param onAfterChange defines action that is fired after position of slider within range is changed
 * @param symbol defines displayed symbol after value in tooltip of dummy-rc-slider
 * @param tipFormatter defines a function to format tooltip's text
 * @param value defines an array with actual values of both sliders
 */

const RangeSlider = ({
    className = '',
    fractionDigits = 0,
    marks = {},
    max,
    min,
    onAfterChange,
    symbol = '',
    tipFormatter = tip => `${tip}`,
    value
}) => {
    const [currentValue, setCurrentValue] = useState(value);

    /** Calculating left|right margin for overflowing tooltips */
    const dummyMin = min?.toFixed(fractionDigits).toString() + ' ' + symbol;
    const dummyMax = max?.toFixed(fractionDigits).toString() + ' ' + symbol;
    const dummyMinTens = dummyMin?.length > 2;
    const dummyMaxTens = dummyMax?.length > 2;
    const dummyMinHundreds = dummyMin?.length > 6;
    const dummyMaxHundreds = dummyMax?.length > 6;
    const dummyMinThouands = dummyMin?.length > 7;
    const dummyMaxThouands = dummyMax?.length > 7;

    useEffect(() => {
        if (value) {
            setCurrentValue(value);
        }
    }, [value]);

    return min === max ? (
        <div className="dummy-rc-slider">
            <div className="dummy-rc-slider-handle">
                <div
                    className={clsx('dummy-rc-slider-tooltip-1', {
                        'ml-10': dummyMinTens,
                        'ml-20': dummyMinHundreds,
                        'ml-30': dummyMinThouands
                    })}
                >
                    {dummyMin}
                </div>
            </div>
            <div className="dummy-rc-slider-track" />
            <div className="dummy-rc-slider-handle">
                <div
                    className={clsx('dummy-rc-slider-tooltip-2', {
                        'mr-10': dummyMaxTens,
                        'mr-20': dummyMaxHundreds,
                        'mr-30': dummyMaxThouands
                    })}
                >
                    {dummyMax}
                </div>
            </div>
        </div>
    ) : (
        <div className="nui-range-slider flex justify-center body-scroll-lock-ignore">
            <Range
                allowCross={false}
                className={clsx('', className)}
                tipFormatter={tipFormatter}
                tipProps={{
                    placement: 'top',
                    visible: true
                }}
                marks={marks}
                max={max}
                min={min}
                onAfterChange={onAfterChange}
                onChange={value => setCurrentValue(value)}
                step={null}
                value={currentValue}
            />
        </div>
    );
};
export default RangeSlider;
